// removed by extract-text-webpack-plugin
module.exports = {"textArea":"_13P-M"};


//////////////////
// WEBPACK FOOTER
// ../src/components/TextArea/TextArea.css
// module id = 509
// module chunks = 0